//
//
//
//
//
//
//
//
//
//
//
//
//
//

import avatar from '@/components/avatar.vue';

export default {
  components: {
    avatar,
  },
  props: {
    avatar_list: {
      type: Array,
      default() {
        return [];
      },
    },
    play_cnt: {
      type: Number,
    },
  },
  computed: {
    avatars() {
      let id_num = 10;
      const avatar_list = this.avatar_list || [];
      const info = avatar_list.map((item) => ({
        id: id_num++,
        ...item,
      }));
      if (this.play_cnt > 8 && this.play_cnt <= 999) {
        info.push({
          id: -1,
          text: this.play_cnt,
        });
      }
      if (this.play_cnt > 999) {
        info.push({
          id: -1,
          text: '999+',
        });
      }
      return info;
    },
  },
  data() {
    return {};
  },
};
